/**
 * iCal Sync Service
 * Phase 1: Audit Only
 * All operations enforce commit: false to prevent database modification.
 */

/**
 * Performs a dry-run audit of an iCal feed.
 * @param {Object} params - The audit parameters.
 * @param {string} params.url - The iCal URL to audit.
 * @param {string} params.authKey - The authorization key for the API.
 */
export const dryRunAudit = async ({ url, authKey }) => {
  if (!url) throw new Error('iCal URL is required');
  if (!authKey) throw new Error('Auth Key is required');

  try {
    // Force commit: false for safety in Phase 1
    const response = await fetch('/api/ical/sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-iCal-Auth': authKey
      },
      body: JSON.stringify({
        url,
        commit: false
      })
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.error || 'Failed to perform iCal audit');
    }

    return result;
  } catch (error) {
    console.error('iCal Audit Error:', error);
    throw error;
  }
};

/**
 * Performs a comprehensive dry-run audit of multiple iCal feeds.
 * @param {Object} params - The audit parameters.
 * @param {string[]} params.urls - Array of iCal URLs to audit.
 * @param {string} params.authKey - The authorization key for the API.
 */
export const dryRunComprehensiveAudit = async ({ urls, authKey }) => {
  if (!urls || !Array.isArray(urls) || urls.length === 0) {
    throw new Error('At least one iCal URL is required');
  }
  if (!authKey) throw new Error('Auth Key is required');

  try {
    // Force commit: false for safety in Phase 1
    const response = await fetch('/api/ical/sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-iCal-Auth': authKey
      },
      body: JSON.stringify({
        urls,
        commit: false
      })
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.error || 'Failed to perform comprehensive iCal audit');
    }

    return result;
  } catch (error) {
    console.error('Comprehensive iCal Audit Error:', error);
    throw error;
  }
};